import TagManager from 'react-gtm-module';
import { BeginCheckout } from '@features/gtm/types/BeginCheckout';
import { PaymentInfo } from '@features/gtm/types/PaymentInfo';
import { ShippingInfo } from '@features/gtm/types/ShippingInfo';
import { Purchase } from '@features/gtm/types/Purchase';



export const beginCheckout = (beginCheckout: BeginCheckout) => {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: 'begin_checkout',
  			ecommerce: beginCheckout,
		}
	});
}



export const addPaymentInfo = (paymentInfo: PaymentInfo) => {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: 'add_payment_info',
  			ecommerce: paymentInfo,
		}
	});
}



export const addShippingInfo = (shippingInfo: ShippingInfo) => {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: 'add_shipping_info',
  			ecommerce: shippingInfo,
		}
	});
}



export const purchase = (purchase: Purchase) => {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });
	TagManager.dataLayer({
		dataLayer: {
			event: 'purchase',
  			ecommerce: purchase,
		}
	});
}